
import { Trans } from "react-i18next";

export function TermsOfUsePrivacyPolicy() {
  return (
    <div className="text-xs text-gray-500 text-center max-w-sm mt-8">
      <Trans
        i18nKey="login.terms_of_use_privacy_policy.agreement"
        components={{
          1: <a href="https://www.bizdesk.ai/app/user_agreement.html" target="_blank" className="text-i-primary hover:text-i-primary mx-1" />,
          3: <a href="https://www.bizdesk.ai/app/privacy_policy.html" target="_blank" className="text-i-primary hover:text-i-primary mx-1" />,
        }}
      />
    </div>
  );
}
